import Http from '@/services/httpAcademy'

export const getFinancialOverview = (params) =>
	Http.get('/admin/financial', { params })

export const getFinancialSettings = () =>
	Http.get('/admin/financial/settings')

export const updateFinancialSettings = (data) =>
	Http.put('/admin/financial/settings', data)

export const listPayouts = (params) =>
	Http.get('/admin/financial/payouts', { params })

export const approvePayout = (id, data) =>
	Http.patch(`/admin/financial/payouts/${id}/approve`, data)

export const rejectPayout = (id, data) =>
	Http.patch(`/admin/financial/payouts/${id}/reject`, data)

export const markPayoutPaid = (id, data) =>
	Http.patch(`/admin/financial/payouts/${id}/mark-paid`, data)
